import React from 'react';
import './VideoMeetingPage.css';

/**
 * GuestThankYouPage Component
 *
 * Shown to guest instructors after they leave a meeting
 * Thanks them for their time and provides info about the platform
 */
const GuestThankYouPage = () => {
  return (
    <div className="video-meeting-page">
      <div className="meeting-content">
        <div className="meeting-create">
          <div className="icon-container success">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h2>Thank You!</h2>
          <p className="meeting-description">
            Thank you for helping someone learn Spanish.
            <br />
            Your time and expertise make a real difference!
          </p>

          <div className="meeting-features" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Practice with native speakers</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📚</span>
              <span>Auto-generated flashcards</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🗣️</span>
              <span>Real conversation practice</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💯</span>
              <span>7-day free trial</span>
            </div>
          </div>

          <div style={{
            padding: '20px',
            backgroundColor: '#f5f5f5',
            borderRadius: '12px',
            marginBottom: '20px',
          }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#333' }}>
              Interested in Learning Spanish?
            </h3>
            <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#666' }}>
              Teacha helps students practice Spanish through video conversations
              with native speakers like you. Conversations are automatically converted
              into flashcards for review.
            </p>
            <a
              href="/"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#FF5722',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
              }}
            >
              Start Your Free Trial
            </a>
          </div>

          <p style={{ fontSize: '14px', color: '#999', marginTop: '20px' }}>
            You can close this tab now
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuestThankYouPage;
